import React from "react";
import PropTypes from "prop-types";

import Button from "../button/Button";
import StatusBadge from "../status-badge/StatusBadge";

const NDASignedBadge = ({ signed = false }) => {
  return (
    <>
      {signed ? (
        <Button
          theme="secondary"
          variant="outlined"
          size="small"
          leftIcon="lock_open"
          rightIcon="chevron_right"
        >
          「NDA締結」バッジを獲得
        </Button>
      ) : (
        <StatusBadge
          label="NDA締結済み"
          color="border"
          leftIcon="lock"
        />
      )}
    </>
  );
};

NDASignedBadge.propTypes = {
  /**
   * NDA締結のステータス
   */
  signed: PropTypes.bool,
};

export default NDASignedBadge;
